<template>
    <v-layout row wrap v-if="!isEmpty">
        <v-flex md12>
            <m-onboard-story v-if="this.verified" :item="onboarding[index]" @skip="skip" @dismiss="dismiss"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import MOnboardStory from "@modules/onboards/concrete/m-onboard-story"
    import {createNamespacedHelpers} from 'vuex'
    import onboardingMock from "@/mocks/onboarding.js"

    const {mapActions} = createNamespacedHelpers('onboardings');

    export default {
        name: "m-block-content-onboarding",
        components: {MOnboardStory},
        props: {
            startFullscreen: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                index: 0
            }
        },
        created() {
            if(this.startFullscreen) {
                this.index++
            }
            if (this.isEmpty) {
                this.redirect(this.nav.dashboard.index.name);
            }
        },
        computed: {
            onboarding() {
                if(this.$route.name == 'dashboard-index') {
                    return this.$user.attributes.onBoarding
                } else {
                    return onboardingMock;
                }
            },
            isEmpty() {
                return this.$lodash.isEmpty(this.onboarding)
            }
        },
        methods: {
            ...mapActions({
                requestDismiss: 'dismiss'
            }),
            skip() {
                this.goToNext()
            },
            checkVerification(){
                this.$emit('checkVerification')
            },
            async dismiss(item) {
                await this.requestDismiss(item)
                this.goToNext()
            },
            goToNext() {
                if (this.onboarding.length - 1 === this.index) {
                    this.redirect(this.nav.dashboard.index.name);
                    return
                }
                this.index++
            }
        }
    }
</script>

<style scoped>

</style>
